import { Component, Input, ViewEncapsulation } from '@angular/core';

import { WebApiModel } from '../../../models/web-api.model';

@Component({
  selector: 'hcf-place-service-category',
  templateUrl: './place-service-category.component.html',
  styleUrls: ['./place-service-category.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class PlaceServiceCategoryComponent {
  @Input() serviceCategory: WebApiModel.ServiceCategory;
  @Input() componentIndex: number;
  @Input() numberOfServiceCategories: number;

  detailsHidden: boolean = false;
  numberOfServices: number = 0;

  setDetailsVisible(): void {
    this.detailsHidden = !this.detailsHidden;
  }
}
